    // Utility for base64
function toBase64(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)));
}

// Import key from environment variable
async function importKey() {
  const secretKey = import.meta.env.VITE_ENCRYPTION_KEY;
  if (!secretKey) {
    throw new Error('VITE_ENCRYPTION_KEY not found in environment variables');
  }
  
  // Convert string key to bytes using PBKDF2-like approach
  const encoder = new TextEncoder();
  const keyMaterial = await crypto.subtle.importKey(
    "raw",
    encoder.encode(secretKey),
    { name: "PBKDF2" },
    false,
    ["deriveBits", "deriveKey"]
  );
  
  return crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: encoder.encode("saddlefit-salt"),
      iterations: 100000,
      hash: "SHA-256"
    },
    keyMaterial,
    { name: "AES-GCM", length: 256 },
    true,
    ["encrypt"]
  );
}

// Encrypt Shopify token - returns JSON string
async function encryptToken(token) {
  const key = await importKey();
  const iv = crypto.getRandomValues(new Uint8Array(12));

  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    new TextEncoder().encode(token)
  );

  // Create the object
  const encryptedData = {
    iv: toBase64(iv),
    ciphertext: toBase64(encrypted),
  };

  // Convert to JSON string and return
  return JSON.stringify(encryptedData);
}

// Export the function
export { encryptToken };